"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementTypeFrom = exports.arrayTypeFrom = exports.isArrayType = exports.schemaRefToString = exports.typeToString = exports.areTypesEqual = exports.isTypePrimitive = exports.MessageSchema = exports.TypeSchema = exports.FunctionType = exports.BufferType = exports.StringType = exports.NumberType = exports.BooleanType = exports.UndefinedType = void 0;
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
/* eslint-disable @typescript-eslint/naming-convention */
exports.UndefinedType = { category: schemas_1.TypeCategory.Undefined };
exports.BooleanType = { category: schemas_1.TypeCategory.Boolean };
exports.NumberType = { category: schemas_1.TypeCategory.Number };
exports.StringType = { category: schemas_1.TypeCategory.String };
exports.BufferType = { category: schemas_1.TypeCategory.Buffer };
exports.FunctionType = { category: schemas_1.TypeCategory.Function };
exports.TypeSchema = {
    category: schemas_1.TypeCategory.Schema,
    schema: {
        name: 'Type',
        path: 'type-schema.proto'
    }
};
exports.MessageSchema = {
    category: schemas_1.TypeCategory.Schema,
    schema: {
        name: 'BufferMessage',
        path: 'message-schema.proto'
    }
};
/* eslint-enable @typescript-eslint/naming-convention */
var isTypePrimitive = function (objectType) {
    if (objectType == null) {
        return false;
    }
    switch (objectType.category) {
        case schemas_1.TypeCategory.Boolean:
        case schemas_1.TypeCategory.Number:
        case schemas_1.TypeCategory.String:
            return true;
        default:
            return false;
    }
};
exports.isTypePrimitive = isTypePrimitive;
// This serves to flatten the underlying concatenated string
var flattenStr = function (str) {
    Number(str);
    return str;
};
var areTypesEqual = function (type1, type2) {
    return exports.typeToString(type1) === exports.typeToString(type2);
};
exports.areTypesEqual = areTypesEqual;
// Stringify IType with stable ordering of properties
var typeToString = function (objectType) {
    if (objectType === undefined) {
        return '';
    }
    if (objectType === null) {
        return 'null';
    }
    var pairs = Object.keys(objectType)
        .sort()
        .map(function (key) { return propertyToString(key, objectType[key]); })
        .filter(function (pair) { return !!pair; }); // Remove non-truthy strings
    return flattenStr('{'.concat(pairs.join(','))
        .concat('}'));
};
exports.typeToString = typeToString;
// Stringify ISchemaRef with stable ordering of properties
var getSchemaRefToString = function (schema) {
    if (schema === undefined) {
        return '';
    }
    if (schema === null) {
        return 'null';
    }
    var pairs = Object.keys(schema)
        .sort()
        .map(function (key) { return propertyToString(key, schema[key]); })
        .filter(function (pair) { return !!pair; }); // Remove non-truthy strings
    return '{'.concat(pairs.join(',')).concat('}');
};
var propertyToString = function (propertyName, propertyValue) {
    if (propertyName === 'schema') {
        return "\"" + propertyName + "\":" + getSchemaRefToString(propertyValue);
    }
    if (propertyName === 'path') {
        return ''; // No schema path, schema name should be unique (e.g., via namespaces)
    }
    if (propertyName === 'nestedArrayLevel') {
        if (!propertyValue) {
            return ''; // Leave off nestedArrayLevel if it is not truthy
        }
        return "\"" + propertyName + "\":" + propertyValue;
    }
    if (propertyValue === undefined) {
        return '';
    }
    if (typeof propertyValue === 'string') {
        return "\"" + propertyName + "\":\"" + propertyValue + "\""; // Quotes
    }
    return "\"" + propertyName + "\":" + propertyValue;
};
exports.schemaRefToString = getSchemaRefToString;
// Returns whether type is an array type
var isArrayType = function (objectType) {
    if (!objectType) {
        return false;
    }
    return objectType.nestedArrayLevel > 0;
};
exports.isArrayType = isArrayType;
// Returns an array type corresponding to the given element type
var arrayTypeFrom = function (objectType) {
    // TODO: Use {...objectType} once detective-typescript version can handle it
    // eslint:disable prefer-object-spread
    var clonedType = __assign({}, objectType);
    clonedType.nestedArrayLevel = exports.isArrayType(objectType) ? objectType.nestedArrayLevel + 1 : 1;
    return clonedType;
};
exports.arrayTypeFrom = arrayTypeFrom;
// Returns an element type corresponding to the given array type
var elementTypeFrom = function (objectType) {
    // TODO: Use {...objectType} once detective-typescript version can handle it
    // eslint:disable prefer-object-spread
    var clonedType = __assign({}, objectType);
    clonedType.nestedArrayLevel = exports.isArrayType(objectType) ? objectType.nestedArrayLevel - 1 : 0;
    return clonedType;
};
exports.elementTypeFrom = elementTypeFrom;
//# sourceMappingURL=ityperegistry.js.map